// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3QuY2","rootCenter":"LoadMoreObserver_rootCenter__2qFvi","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__aNob7"};